import React from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { BiData, TopNavClickBiEvent } from '@wix/da-bi/pkg/events';
import IconButtonWithNotification from '@wix/da-ds/pkg/Buttons/IconButtonWithNotification';
import CartIcon from '@wix/da-ds/pkg/Icons/Cart';

export interface Props {
  cartCount: number;
  className?: string;
  iconClassName?: string;
  numberClassName?: string;
}

const CartIconButton: React.FC<Props> = ({
  cartCount,
  className,
  iconClassName,
  numberClassName,
}) => {
  const { t } = useTranslation();
  return (
    <IconButtonWithNotification
      icon={CartIcon}
      size="medium"
      notificationColor="green"
      className={className}
      iconButtonClassName={iconClassName}
      numberClassName={numberClassName}
      count={cartCount}
      biData={BiData<TopNavClickBiEvent>({
        evid: 700,
        link_url: URLS.CART,
        link_name: 'cart',
        indicator: cartCount,
      })}
      href={URLS.CART}
      aria-label={t('siteHeader.a11y.cart.withItems', {
        formattedCount: cartCount,
      })}
    />
  );
};
CartIconButton.displayName = 'CartIconButton';

export default CartIconButton;
